(function() {
    window.rewardService = {
      get(data) {
        return axios.get('/api/reward/points/get.php');
      },
      save(data) {
        return axios.post('/api/reward/points/save.php', data);
      },
    }
  })();